import cn from 'classnames';
import { Badge, Card, Typography } from 'seagull';
import { useResponsive } from "../../../../../client-flow/contexts";
import { useIoContext } from "../../../../../contexts";
import styles from "./VideoCardItem.module.scss";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const VideoCardItem = _ref => {
  let {
    video,
    onSelect,
    isActive
  } = _ref;
  const {
    isPortrait
  } = useResponsive();
  const {
    YoutubePlayer
  } = useIoContext();
  const {
    id,
    title,
    watched,
    duration
  } = video;
  const videoWidth = isPortrait ? '358px' : '179px';
  const videoHeight = isPortrait ? '224px' : '112px';
  return /*#__PURE__*/_jsx("div", {
    className: styles.VideoItemContainer,
    children: /*#__PURE__*/_jsxs(Card, {
      className: cn(styles.VideoItemCard, {
        [styles.played]: isActive
      }),
      "data-testid": "tutorial-video-".concat(video.id),
      as: "button",
      highlightOnHover: true,
      onClick: () => onSelect(video),
      children: [/*#__PURE__*/_jsx(YoutubePlayer, {
        className: styles.thumbnail,
        controls: false,
        playIcon: /*#__PURE__*/_jsx(_Fragment, {}),
        width: videoWidth,
        height: videoHeight,
        light: true,
        url: "https://youtu.be/".concat(id)
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.videoInfo,
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: isPortrait ? 'h3' : 'paragraph2',
          weight: "bold",
          className: styles.videoTitle,
          "data-testid": "tutorial-video-title",
          children: title
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.durationRow,
          children: [/*#__PURE__*/_jsx(Typography, {
            className: styles.videoDuration,
            variant: isPortrait ? 'h4' : 'paragraph2',
            weight: "light",
            "data-testid": "tutorial-video-duration",
            children: "".concat(duration, " min")
          }), watched && /*#__PURE__*/_jsx(Badge, {
            className: cn(styles.watchedBadge, {
              [styles.isPortrait]: isPortrait
            }),
            rounded: true,
            outlined: true,
            skin: "success",
            size: isPortrait ? 'big' : 'default',
            "data-testid": "tutorial-video-watched-tag",
            children: "Watched"
          })]
        })]
      })]
    })
  });
};